import styled, { css, keyframes } from 'styled-components'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import { BaseButton, Flex } from 'vvs-uikit'

import { GachaponState } from './types'

export const GachaponButton = styled(BaseButton)<{ state: GachaponState }>`
  position: relative;
  width: 62.03px;
  height: 62.03px;
  margin: -8px 12px -10px 0;
  border-style: solid;
  border-width: 4.14px;
  border-radius: 50%;
  ${({ state, theme }) =>
    state === 'init'
      ? css`
          top: 10px;
          background-color: ${theme.colors.primary};
          border-color: ${theme.colors.darkCyan};
        `
      : state === 'eligible'
      ? css`
          top: 10px;
          background-color: ${theme.colors.goldLight};
          border-color: ${theme.colors.brightYellow};
        `
      : css`
          background-color: ${theme.colors.grey};
          border-color: ${theme.colors.tertiarySilver};
        `}
  cursor: pointer;

  filter: drop-shadow(3px 4px 0 #00000026);
  transform: translate(0, 0);
  transition: 100ms transform, 100ms filter;

  &:hover {
    transform: translate(-2px, -2.66px);
    filter: drop-shadow(5px 6.66px 0 #00000026);
  }
  &:active {
    transform: translate(3px, 4px);
    filter: drop-shadow(0px 0px 0 #00000026);
  }
`

const jumpingSlow = keyframes`
	0%   { transform: scale(1, 1)         translateY(0); }
	2.5%  { transform: scale(1.1, 0.9)    translateY(3px); }
	7.5%  { transform: scale(0.9, 1.1)    translateY(-20px); }
	12.5%  { transform: scale(1.05, 0.95) translateY(0); }
	15%  { transform: scale(1, 1)         translateY(-4px); }
	17.5%  { transform: scale(1, 1)       translateY(0); }
	100% { transform: scale(1, 1)         translateY(0); }
`
const jumpingFast = keyframes`
	0%   { transform: scale(1, 1)       translateY(0); }
	10%  { transform: scale(1.1, 0.9)   translateY(3px); }
	30%  { transform: scale(0.9, 1.1)   translateY(-20px); }
	50%  { transform: scale(1.05, 0.95) translateY(0); }
	60%  { transform: scale(1, 1)       translateY(-4px); }
	70%  { transform: scale(1, 1)       translateY(0); }
	100% { transform: scale(1, 1)       translateY(0); }
`
export const GachaponButtonIcon = styled(PixelatedImage)<{ state: GachaponState }>`
  position: relative;

  ${({ state }) =>
    state === 'init'
      ? css`
          top: -13px;
          animation: 6000ms ease 4000ms infinite normal both running ${jumpingSlow};
        `
      : state === 'eligible'
      ? css`
          top: -13px;
          animation: 1500ms ease 500ms infinite normal both running ${jumpingFast};
        `
      : css`
          top: -1px;
        `}
`

export const GachaponCountdownLabel = styled(Flex)<{ state: GachaponState }>`
  position: absolute;
  left: 50%;
  bottom: -15px;
  white-space: nowrap;
  padding: 2px 9px 3px;
  transform: translate(-50%, 0);
  background-color: ${({ state, theme }) =>
    state === 'init'
      ? theme.colors.darkCyan
      : state === 'eligible'
      ? theme.colors.warningLight
      : theme.colors.tertiarySilver};
  border-radius: 50px;
`

export const GachaponDoneIcon = styled(PixelatedImage)`
  position: absolute;
  top: -3px;
  right: -12px;
  width: 34px;
  height: 34px;
`
